var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 0.666664C2.77435 0.666664 0.166016 3.275 0.166016 6.5C0.166016 10.875 5.99935 17.3333 5.99935 17.3333C5.99935 17.3333 11.8327 10.875 11.8327 6.5C11.8327 3.275 9.22435 0.666664 5.99935 0.666664ZM5.99935 8.58333C4.84935 8.58333 3.91602 7.65 3.91602 6.5C3.91602 5.35 4.84935 4.41666 5.99935 4.41666C7.14935 4.41666 8.08268 5.35 8.08268 6.5C8.08268 7.65 7.14935 8.58333 5.99935 8.58333Z",
    fill: "#69757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1a72e0e503daf5d1783634f9f874fa2c.svg";
export { ForwardRef as ReactComponent };